const $burger = $('.js-burger-trigger');
const $window = $(window);
const $body = $('body');
const $headerContent = $('.header__content-wrapper');
const $hasDropDown = $headerContent.find('.has-dropdown');
const $header = $('.header');

/**
 * Handle Burger Trigger
 *
 * @param  {Event} event
 * @return {Void}
 */
$burger.on('click', function(event) {
  event.preventDefault();

  const $this = $(this);
  const $headerContent = $this.closest('.header').find('.header__content-wrapper');
  $this.toggleClass('btn-burger--triggered');
  $body.toggleClass('overflow-hidden');
  $header.toggleClass('is-active');

  $headerContent.toggleClass('is-active');
  $hasDropDown.removeClass('is-active');
});

/**
 * Stop Propagation
 *
 * @return {Void}
 */
$('.header__content, .btn-burger').click(function(event) {
  event.stopPropagation();
})

/**
 * Close
 *
 * @return {Void}
 */
function close() {
  if ($headerContent.hasClass('is-active')) {
    $body.removeClass('overflow-hidden');
    $burger.toggleClass('btn-burger--triggered');
    $headerContent.toggleClass('is-active');
    $headerContent.find('.is-active').each(function() {
      $(this).toggleClass('is-active');
    });
    $header.toggleClass('is-active');
    $headerContent.find('.dropdown__nav-level-2').slideDown();
  }
}

/**
 * Close on body
 *
 * @return {Void}
 */
$body.click(function() {
  close();
})

/**
 * Close on button
 *
 * @return {Void}
 */
$('.js-close-burger').on('click', function() {
  close();
})

/**
 * Close on click
 *
 * @return {Void}
 */
$headerContent.find('.header__content-close').on('click', function() {
  close();
})
